module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "operation-wrapper"
  }, [_c('div', {
    staticClass: "operation-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/xiaoyuan'
    }
  }, [_c('div', {
    staticClass: "operation-text"
  }, [_vm._v("校园管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "operation-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/yunying'
    }
  }, [_c('div', {
    staticClass: "operation-text"
  }, [_vm._v("运营管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "operation-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/user'
    }
  }, [_c('div', {
    staticClass: "operation-text"
  }, [_vm._v("用户管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "operation-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/secretary'
    }
  }, [_c('div', {
    staticClass: "operation-text"
  }, [_vm._v("小秘书")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5735480b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 1033
// module chunks = 0